import React from "react";
import { useTranslation } from "react-i18next";
import { LinkedAccount } from "../../../../models/LinkedAccount";
import {
  getLinkedAccountAge,
  getLinkedAccountDisplayName,
  getLinkedAccountInitials,
} from "../../../../../utils/linkedAccountDisplay";

export interface SurveyAccountOptionProps {
  name: string;
  account: LinkedAccount;
  accountId: string;
  checked: boolean;
  isCurrentUser?: boolean;
  onChange: (value: string) => void;
}

const SurveyAccountOption: React.FC<SurveyAccountOptionProps> = ({
  name,
  account,
  accountId,
  checked,
  isCurrentUser = false,
  onChange,
}) => {
  const { t } = useTranslation();
  const displayName = getLinkedAccountDisplayName(account);
  const initials = getLinkedAccountInitials(account);
  const age = getLinkedAccountAge(account);

  return (
    <label
      className={`survey-account-select__option ${checked ? "survey-account-select__option--selected" : ""}`}
    >
      <input
        type="radio"
        name={name}
        value={accountId}
        checked={checked}
        className="survey-account-select__option-input"
        onChange={() => onChange(accountId)}
      />
      <div className="survey-account-select__option-avatar" aria-hidden>
        {initials}
      </div>
      <div className="survey-account-select__option-content">
        <span className="survey-account-select__option-name">
          {displayName}
          {isCurrentUser ? (
            <span className="survey-account-select__option-you"> {t("survey_account_you_label")}</span>
          ) : null}
        </span>
        {age !== null && (
          <span className="survey-account-select__option-meta body-text-small text-color-dark-gray">
            {age} {t("my_account_age_unit")}
          </span>
        )}
      </div>
    </label>
  );
};

export default SurveyAccountOption;
